__turbopack_context__.v({
  "actionButton": "_502_xa_actionButton",
  "counter": "_502_xa_counter",
  "description": "_502_xa_description",
  "inlineWrapper": "_502_xa_inlineWrapper",
  "leftSection": "_502_xa_leftSection",
  "reloadButton": "_502_xa_reloadButton",
  "title": "_502_xa_title",
  "titleRow": "_502_xa_titleRow",
  "wrapper": "_502_xa_wrapper",
});
